/** @jsxImportSource @emotion/react */
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import {
  Box,
  Button,
} from '@mui/material';
import { t } from 'i18next';
import { styles } from './styles';
import { useMemo } from 'react';

type Props = {
  url: string;
  onDelete: () => void;
};

const getFileNameFromUrl = (url: string): string => {
  try {
    const pathname = new URL(url).pathname;
    const fileName = pathname.split('/').pop();

    return fileName
      ? decodeURIComponent(fileName)
      : 'Document';
  } catch {
    return 'Document';
  }
};

const testIsSafari = (): boolean => {
  const ua = navigator.userAgent;

  return (
    /Safari/i.test(ua) &&
    !/Chrome|CriOS|Chromium|Edg|EdgiOS|OPR|OPiOS|FxiOS/i.test(ua)
  );
};

const DocumentBox = ({ url, onDelete }: Props) => {
  const fileName = getFileNameFromUrl(url);

  const isPdf = useMemo(() => fileName?.endsWith('.pdf'), [fileName]);
  const isSafari = useMemo(testIsSafari, []);


  const urlDownload = () => {


      const a = document.createElement('a');
        a.href = url;
        a.download = fileName ? fileName : `INVISION Document`;
        a.click();
  }

  const handleView = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleDownload = () => {
    fetch(url).then(res => {
      res.blob().then(async blob => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName ? fileName : `INVISION Document`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(link.href);
      });
    });
  };

  return (
    <div style={{maxWidth: '250px'}}>
        <Box
            sx={{
                display: 'flex',
                alignContent: 'center',
                alightItems: 'center',
                justifyContent: 'center', 
                justifyItems: 'center',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                flexDirection: 'column',
                padding: 2,
                
            }}
            >
                <Box sx={{display: 'flex', width: '100%', justifyContent: 'center'}}>
                    <InsertDriveFileOutlinedIcon color="action" />
                </Box>
                <div>{fileName}</div>
        </Box>
        
        <div css={styles.photosActions}>


            
            <Button variant="text" size="small" color="error" onClick={onDelete}>
                {t('general.delete')}
            </Button>

            {isSafari ? (
                <>
                    {
                        isPdf ? ( // Safari Pdf
                            <Button variant="text" size="small" onClick={handleView} color="info">
                                {t('general.view')}
                            </Button>
                        ) : ( // Safari documents
                            <Button variant="text" size="small" onClick={urlDownload} color="info">
                                {t('general.view')}
                            </Button>
                        )
                    }
                </>
            ): (
                <>
                    {
                        isPdf ? ( // Chrome Pdfs
                            <>
                                <Button variant="text" size="small" onClick={urlDownload} color="info">
                                    {t('general.view')}
                                </Button>
                                <Button variant="text" size="small" onClick={handleDownload}>
                                    {t('general.download')}
                                </Button>
                            </>
                        ) : ( // Chrome documents
                            <>
                                <Button variant="text" size="small" onClick={urlDownload} color="info">
                                    {t('general.download')}
                                </Button>
                            </>
                        )
                    }    
                </>
            )}
        </div>
    </div>
  );
};

export default DocumentBox;